import Vue from 'vue'
import store from '../../store'
import * as signalR from '@aspnet/signalr'

// 七牛上传图片前缀
const QN_UPLOAD_URL = 'https://upload-z2.qiniup.com'
// 默认图片
const DEFAULT_IMAGE = 'http://publicfiles.chehuijia.com.cn//UploadFile/Commons/Public/Images/450x300.png'
// 默认图片方形
const DEFAULT_IMAGE_square = 'http://publicfiles.chehuijia.com.cn//UploadFile/Commons/Public/Images/200x200.png'
// 腾讯地图
const map_url = 'https://apis.map.qq.com/'
// 默认token
const default_token = 'dfeb02d6'
// 接口基础路径
// const _serverRoot = ''
// socket基础路径
let socket_base_url = 'https://localhost:44329'
// 搜索引擎基础路径
let SEARCH_URL = 'https://localhost:44373'
// B端接口基础路劲
const entp_URL = process.env.NODE_ENV === 'production' ? 'https://entp.chehuijia.com.cn/' : 'https://localhost:44372'
// const axios_base_url = _serverRoot + '/api'
const axios_base_url = '/api'
// 七牛获取图片前缀
let QN_URL_BASE = 'http://trashfiles.chehuijia.com.cn/'


let ROOT = null

//线上环境
if (process.env.NODE_ENV === 'production') {
    //测试环境
    if (window.location.href.indexOf("dev") != -1) {
        socket_base_url = 'http://dev.csr.chehuijia.com.cn';
        SEARCH_URL = 'http://dev.common.api.chehuijia.com.cn/';
    } else {
        //生成环境
        socket_base_url = 'https://csr.chehuijia.com.cn';
        SEARCH_URL = 'https://common.api.chehuijia.com.cn/';
        QN_URL_BASE = 'http://publicfiles.chehuijia.com.cn/'
    }
}



/**
 * socket 相关接口  start
 * */
let connection
// 1.初始化websocket
function initWebSocket(id) {
    return new Promise((resolve) => {
        connection = new signalR.HubConnectionBuilder()
            .withUrl(socket_base_url + `/servicehub?uType=-1&uid=${id}`)
            .build();
        connection.start().then(() => {
            resolve()
        }).catch((err) => {
            console.log(err)
            store.commit('updateConnectState', 5)
        });
        // 监听断开
        connection.onclose(() => {
            store.commit('updateConnectState', 0)
            console.log("socket断开")
        })
    })

}
// 关闭socket
function closeSocket() {
    // 断开连接
    connection.stop()
}
// 接收websocket信息
function receiveWebsocket(callback) {
    connection.on('NoticeCService', function (res) {
        console.log(res)
        callback && callback(res)
    })
}
// 发送信息
function sendSocket(params, callback) {
    Vue.axios.post('/ChatCenter/SendMsgToSingle', {
            "sId": getSessionStorage('userMsg').Id,
            "cId": params.cId,
            "contentType": params.contentType,
            "content": typeof params.content == 'string' ? params.content : JSON.stringify(params.content),
            "SessionId": params.SessionId,
            "senderType": 1,
            "ObjectId": params.ObjectId
        })
        .then((response) => {
            console.log(response)
            callback && callback(response.data)
        })
}
// 发送留言
function sendLeaveMeg(params, callback) {
    Vue.axios.post('/ChatCenter/LeaveMessageToCustomer', {
            "sId": getSessionStorage('userMsg').Id,
            "uId": params.cId,
            "contentType": params.contentType,
            "content": typeof params.content == 'string' ? params.content : JSON.stringify(params.content),
            "ObjectId": params.ObjectId
        })
        .then((response) => {
            console.log(response)
            callback && callback(response.data)
        })
}
// 设为已读
function markRead(cId, cType) {
    Vue.axios.post('/ChatCenter/SessionContentsSetRead', {
        "sId": getSessionStorage('userMsg').Id,
        "cId": cId,
        "cType": cType,
        "reciever": 1
    })
}
// 结束聊天
function stopChat(sessionId) {
    return new Promise((resolve, reject) => {
        Vue.axios.post('/ChatCenter/EndChat?sessionId=' + sessionId).then((res) => {
            resolve(res)
        })
    })

}
//添加到聊天列表
function AddCustomerToChat(uId) {
    return new Promise((resolve) => {
        Vue.axios.post('/ChatCenter/AddCustomerToChat?cid=' + uId).then((res) => {
            resolve(res)
        })
    })
}
// 获取其他在线客服
function getOtherServes(key) {
    return new Promise((resolve, reject) => {
        Vue.axios.get('/ChatCenter/GetOnLineServe', {
                params: {
                    search: key ? key : null,
                    sid: getSessionStorage('userMsg').Id
                }
            })
            .then((response) => {
                resolve(response.data)
            })
    })
}

/**
 * socket 相关接口  end
 * */
// axios Get
function axiosGet(params) {
    let url = ''
    if (params.search && process.env.NODE_ENV === 'production') {
        url = SEARCH_URL + params.url.replace("/search", "/api")
    } else if (params.map && process.env.NODE_ENV === 'production') {
        url = map_url + params.url.replace("/map", "")
    } else {
        url = params.url
    }
    return new Promise((resolve, reject) => {
        Vue.prototype.axios.get(
                url, {
                    baseURL: '',
                    responseType: params.QRImg ? 'arraybuffer' : null,
                    params: params.data ? params.data : null,
                })
            .then((response) => {
                // console.log(response)
                // 例外
                if (params.exception) {
                    let _data = response.data
                    resolve(_data)
                    return
                }
                if (response.status == 200 && (response.data.errcode == 0 || response.data.errcode == 200)) {
                    let _data = response.data
                    resolve(_data)
                } else {
                    errorMsg(response.data.errmsg)
                    reject()
                }
            })
            .catch((error) => {
                if (!params.map) {
                    errorMsg(error)
                    params.error && params.error()
                }
                reject(error)
            });
    })
}
// axios Post
function axiosPost(params) {
    let timestamp = (new Date()).getTime();
    let token = getUrlParam("Token")
    let url = ''
    if (params.search && process.env.NODE_ENV === 'production') {
        url = SEARCH_URL + params.url.replace("/search", "/api")
    } else if (params.entp && process.env.NODE_ENV === 'production') {
        url = entp_URL + params.url.replace("/entp", "/api")
    } else {
        url = params.url
    }
    return new Promise((resolve, reject) => {
        Vue.prototype.axios({
                baseURL: '',
                method: 'post',
                url: url,
                data: params.data ? params.data : null,
                headers: {
                    'access-key': token,
                    'timestamp': timestamp,
                    'reqApp': 'EntpWeb'
                }
            })
            .then((response) => {
                // 例外
                if (params.exception) {
                    let _data = response.data
                    resolve(_data)
                    return
                }
                if (response.status == 200 && (response.data.errcode == 0 || response.data.errcode == 200)) {
                    let _data = response.data
                    resolve(_data)
                } else {
                    errorMsg(response.data.errmsg)
                    reject()
                }
            })
            .catch((error) => {
                errorMsg(error)
                reject()
            });
    })
}

function getTree() {

    let token = getUrlParam("Token")
    if (token) {
        Vue.axios.get("/Common/GetModulesTree", {
            params: {
                token: token
            }
        }).then((res) => {
            let _root = null
            if (res.data.data[0]) {
                _root = res.data.data[0]
                ROOT = _root
                setSessionStorage('root', _root)
            } else {
                ROOT = null
                setSessionStorage('root', null)
            }
            return (_root)
        })
    }
}
// 根据名称获取该节点
async function getNode(nodeName, level) {
    // let tree = getSessionStorage('root')
    let tree
    if (ROOT) {
        tree = ROOT
    } else {
        let token = getUrlParam("Token")
        let _tree = await Vue.axios.get("/Common/GetModulesTree", {
            params: {
                token: token
            }
        })
        tree = _tree.data.data[0]
        ROOT = tree
    }
    let node = mapTree(tree, nodeName)
    if (node) {
        if (node.Children[0]) {
            if (level == 1) {
                for (let i = 0; i < node.Children.length; i++) {
                    if (node.Children[i].Children[0] && node.Children[i].Children[0].Children[0]) {
                        node.Children[i].Item.Url = node.Children[i].Children[0].Children[0].Item.Url
                    }
                }
            } else if (level == 2) {
                for (let i = 0; i < node.Children.length; i++) {
                    if (node.Children[i].Children[0]) {
                        node.Children[i].Item.Url = node.Children[i].Children[0].Item.Url
                    }
                }
            }
        }
        let _menu = []
        if (node.Children[0]) {
            for (let j = 0; j < node.Children.length; j++) {
                _menu.push(node.Children[j].Item)
            }
        } else {
            _menu = node
        }
        return _menu
    }
}
// 遍历树
function mapTree(node, nodeName) {
    let result = null
    if (!node) {
        return null
    }
    if (node.Item.Name == nodeName) {
        result = node
    } else {
        if (node.Children[0]) {
            for (let i = 0; i < node.Children.length; i++) {
                if (result) {
                    break
                }
                if (node.Children[i].Item.Name == nodeName) {
                    result = node.Children[i]
                    break
                } else {
                    result = mapTree(node.Children[i], nodeName)
                }
            }
        }
    }
    return result
}

function getPermission(node) {
    return new Promise((resolve, reject) => {
        getNode(node).then((res) => {
            let _permission = res.Item.Elements
            let result = {}
            for (let i = 0; i < _permission.length; i++) {
                result[_permission[i].Name] = true
            }
            resolve(result)
        })
    })
}
// 获取当前url中的参数
function getUrlParam(name) {
    // let target = url ? url.substr(url.indexOf('?')) : window.location.hash.substr(2);
    let target = window.location.search ? window.location.search : window.location.hash.substr(2);
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = target.substr(1).match(reg);
    if (r != null) return (r[2]);
}
//获取当前时间
function getNowFormatTime() {
    let date = new Date();
    let seperator2 = ":";
    let strHours = date.getHours();
    let strMinutes = date.getMinutes();
    if (strHours >= 0 && strHours <= 9) {
        strHours = "0" + strHours;
    }
    if (strMinutes >= 0 && strMinutes <= 9) {
        strMinutes = "0" + strMinutes;
    }
    let currentdate = strHours + seperator2 + strMinutes
    return currentdate;
}
// 获取当前日期
function getNowFormatDate() {
    let date = new Date();
    let seperator1 = "-";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate
    return currentdate;
}
// 上传图片时获取token
function geToken(fileDomain, fileType, isPrivate) {
    return new Promise((resolve, reject) => {
        Vue.axios.get('/Common/GetUploadToken', {
                params: {
                    fileDomain: fileDomain, // 表名
                    fileType: fileType, // 文件类型
                    isPrivate: isPrivate, //是否私有
                }
            })
            .then((response) => {
                resolve(response.data.data)
            })
            .catch((error) => {
                console.log(error);
            });
    })

}
// 获取客服组
function getServiceGroup() {
    Vue.axios.get('/CSRManagement/GetServiceGroup')
        .then((response) => {
            store.commit('updateServiceGroup', response.data.data)
        })
        .catch((error) => {
            console.log(error);
        });
}
// 根据客服组Id获取客服
const GetServicesByGId = (groupId) => {
    return new Promise((resolve, reject) => {
        Vue.axios.get('/CSRManagement/GetServicesByGId', {
                params: {
                    GId: groupId
                }

            })
            .then((response) => {
                resolve(response.data.data)
            })
            .catch((error) => {
                console.log(error);
            });
    })
}
// 成功弹窗
function successMsg(text) {
    Vue.prototype.$message({
        message: text,
        type: 'success'
    });
}
// 警告弹窗
function warningMsg(text) {
    Vue.prototype.$message({
        message: text,
        type: 'warning'
    });
}
// 错误弹窗
function errorMsg(text) {
    Vue.prototype.$message.error(text);
}
// 公用删除提示
function elConfirm(params) {
    let that = params.that
    that.$confirm(params.content, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(() => {
        params.confirm && params.confirm()
        if(params.confirmMsg){
            that.$message({
                type: 'success',
                message: params.confirmMsg 
            });
        }

    }).catch((e) => {
        console.log(e)
    });
}
// 校验手机号
let checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('手机号不能为空'));
    } else {
        const reg = /^$|^(1[3584]\d{9})$/
        if (reg.test(value)) {
            callback();
        } else {
            return callback(new Error('请输入正确的手机号'));
        }
    }
};
// 校验 邮箱
let checkEmail = (rule, value, callback) => {

    const reg = /^$|^\w+@[a-z0-9]+\.[a-z]{2,4}$/
    if (reg.test(value)) {
        callback();
    } else {
        return callback(new Error('请输入正确的邮箱'));
    }

};
// 校验正数
let checkInt = (rule, value, callback) => {
    if (!value) {
        return callback(new Error('请输入大于0的数字'));
    } else {
        if (Number(value) > 0) {
            callback();
        } else {
            return callback(new Error('请输入大于0的数字'));
        }
    }
};
// 存储SessionStorage
function setSessionStorage(key, obj) {
    let str = JSON.stringify(obj);
    sessionStorage.setItem(key, str)

}
// 读取SessionStorage
function getSessionStorage(key) {
    let str = sessionStorage.getItem(key)
    let obj = JSON.parse(str)
    return obj
}
// 删除SessionStorage
function clearSessionStorage(key) {
    sessionStorage.removeItem(key)
}
// 存储LocalStorage
function setLocalStorage(key, obj) {
    let str = JSON.stringify(obj);
    localStorage.setItem(key, str)
}
// 读取LocalStorage
function getLocalStorage(key) {
    let str = localStorage.getItem(key)
    let obj = JSON.parse(str)
    return obj
}
// 删除LocalStorage
function clearLocalStorage(key) {
    localStorage.removeItem(key)
}
// 图片上传前校验
function uploadCheck(file) {
    const isJPG = file.type === 'image/jpeg';
    const isGIF = file.type === 'image/gif';
    const isPNG = file.type === 'image/png';
    const isBMP = file.type === 'image/bmp';
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJPG && !isGIF && !isPNG && !isBMP) {
        this.$util.warningMsg('上传图片必须是JPG/GIF/PNG/BMP 格式!');
    }
    if (!isLt2M) {
        this.$util.warningMsg('上传图片大小不能超过 2MB!');
    }
    return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
}
// 获取浏览器版本
function getExplorerInfo() {
    let explorer = window.navigator.userAgent.toLowerCase();
    //ie
    if (explorer.indexOf('msie') >= 0) {
        let ver = explorer.match(/msie ([\d.]+)/)[1];
        return {
            type: 'IE',
            version: ver
        };
    }
    //firefox
    else if (explorer.indexOf('firefox') >= 0) {
        let ver = explorer.match(/firefox\/([\d.]+)/)[1];
        return {
            type: 'Firefox',
            version: ver
        };
    }
    //Chrome
    else if (explorer.indexOf('chrome') >= 0) {
        let ver = explorer.match(/chrome\/([\d.]+)/)[1];
        return {
            type: 'Chrome',
            version: ver
        };
    }
    //Opera
    else if (explorer.indexOf('opera') >= 0) {
        let ver = explorer.match(/opera.([\d.]+)/)[1];
        return {
            type: 'Opera',
            version: ver
        };
    }
    //Safari
    else if (explorer.indexOf('Safari') >= 0) {
        let ver = explorer.match(/version\/([\d.]+)/)[1];
        return {
            type: 'Safari',
            version: ver
        };
    }
}
// 提交浏览记录
function browseRecord(ops, that, ObjId) {
    let sys = getExplorerInfo()
    let Browser = sys.type
    let BrowserVer = sys.version
    if (ops == 1) {
        that.recordStart = timeForRecord()
    } else if (ops == 2) {
        let _router = that.$route
        let currentPage = _router.path
        let prevPage = _router.params.prevPath
        let recordStart = that.recordStart
        let recordEnd = timeForRecord()
        axiosPost({
            url: '/search/CollectionDatas/SubmitBrowseData',
            data: {
                ObjId: ObjId,
                UId: getSessionStorage("userMsg").uid,
                RefererUrl: prevPage,
                Url: currentPage,
                PlaformType: 'entp_pc_client',
                Browser: Browser,
                BrowserVer: BrowserVer,
                UType: '1',
                StartBrowseTime: recordStart,
                EndBrowseTime: recordEnd
            },
            search: true
        })
    }
}

function timeForRecord() {
    let date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    return [year, month, day].map(formatNumber).join('/') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}
const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}
function searchEntp(key) {
    return new Promise(resolve => {
        Vue.axios
        .get("/ShareInventory/GetEnteList?limit=10&name="+key, {data:true})//data=true表示不启用遮罩层
        .then((res) => {
            resolve(res.data);
        })
    });
}
export default {
    QN_URL_BASE,
    QN_UPLOAD_URL,
    default_token,
    axios_base_url,
    DEFAULT_IMAGE,
    DEFAULT_IMAGE_square,
    browseRecord,
    uploadCheck,
    elConfirm,
    getServiceGroup,
    GetServicesByGId,
    geToken,
    getNowFormatTime,
    getNowFormatDate,
    initWebSocket,
    sendSocket,
    receiveWebsocket,
    closeSocket,
    getUrlParam,
    successMsg,
    warningMsg,
    errorMsg,
    checkInt,
    checkPhone,
    checkEmail,
    markRead,
    setLocalStorage,
    getLocalStorage,
    clearLocalStorage,
    setSessionStorage,
    getSessionStorage,
    clearSessionStorage,
    sendLeaveMeg,
    stopChat,
    AddCustomerToChat,
    getOtherServes,
    getNode,
    getPermission,
    getTree,
    axiosPost,
    axiosGet,
    searchEntp
}